import { NavMarker } from 'react-rhumb';
import { Spacer } from 'foundations-components/components/Spacer';
import { AnimatedStepBody } from '../../animation/StepBodyAnimations';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { TrackWhen, useExperiment } from '../../experiments/useExperiment';
import { getFlowConfig } from '../../flow-initial/getFlowConfig';
import { OAuthSignupSection } from '../../oauth/OAuthSignupSection';
import { useResponsiveness } from '../../responsiveness/ResponsivenessProvider';
import { Data } from 'signup-constants/signupData/Data';
import { Step } from 'signup-constants/Step';
import { getHaveAnAccountMessage } from '../HaveAnAccountLink';
import { LandingPageTitle } from '../LandingPageTitle';
import { useLandingPage } from '../useLandingPage';
import { useWorkEmailLabel } from '../useWorkEmailLabel';
import { Content } from 'signup-components/components/SidePanelLayout/SidePanelLayout';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { SidePanelHaveAnAccountLink } from 'signup-components/components/HaveAnAccountLink/sidePanelLayout/SidePanelHaveAnAccountLink';
import { getLoginUrl } from '../../http-login/getLoginUrl';
import { getLoginRedirectUrl } from '../getLoginRedirectUrl';
import { useTracker } from '../../tracking/useTracker';
import { getFullUrl } from 'hubspot-url-utils';
import { SignupDataInput } from '../../signup-data/SignupDataInput';
import { useSignupData } from '../../signup-data/useSignupData';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useIsStepDataValid } from '../../hooks/useIsStepDataValid';
import { SidePanelManageCookies } from 'signup-components/components/ManageCookies/SidePanelManageCookies';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import PrivacyPolicy from '../../views-components/PrivacyPolicy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SidePanelLandingPageView = () => {
  const Tracker = useTracker();
  const stepKey = Step.LandingPage;
  const {
    emailSignupEnabled
  } = getFlowConfig();
  const {
    chooseEmailSignUp
  } = useLandingPage(stepKey);
  const {
    isMobile,
    isDesktop
  } = useResponsiveness();
  useExperiment(ExperimentKeys.ACQ0170, TrackWhen.enrolled);
  const loginRedirectUrl = getLoginRedirectUrl();
  const trackLoginClick = () => {
    Tracker.signupInteraction('click-login-have-an-account', {}, true);
    Tracker.redirect({
      url: `${getFullUrl('app')}/login`
    });
  };
  const {
    labelOverride
  } = useWorkEmailLabel();
  const {
    isValid
  } = useSignupData(Data.Email);
  const onSubmit = evt => {
    if (evt) evt.preventDefault();
    const isReadyToSubmit = isValid && chooseEmailSignUp;
    if (isReadyToSubmit) {
      chooseEmailSignUp();
    }
  };
  const isStepDataValid = useIsStepDataValid(stepKey);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: Step.LandingPage,
    children: /*#__PURE__*/_jsx(Content, {
      centerAlign: true,
      children: /*#__PURE__*/_jsx(TFlex, {
        flexDirection: "column",
        justifyContent: "center",
        marginInline: "auto",
        maxInlineSize: "408px",
        children: /*#__PURE__*/_jsx(AnimatedStepBody, {
          animationDelay: true,
          children: /*#__PURE__*/_jsxs(TFlex, {
            alignItems: "center",
            "data-selenium": `${stepKey}_VIEW`,
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(LandingPageTitle, {
              isMobile: isMobile
            }), /*#__PURE__*/_jsxs(View, {
              maxInlineSize: "400px",
              children: [/*#__PURE__*/_jsx(OAuthSignupSection, {
                shouldShowSeperator: emailSignupEnabled
              }), emailSignupEnabled && /*#__PURE__*/_jsx("form", {
                action: "blue-button-in-all-fields-ios",
                onSubmit: onSubmit,
                children: /*#__PURE__*/_jsxs(Flex, {
                  gap: "400",
                  inlineSize: "100%",
                  children: [/*#__PURE__*/_jsx(View, {
                    flexGrow: 1,
                    children: /*#__PURE__*/_jsx(SignupDataInput, {
                      dataKey: Data.Email,
                      formControlMaxInlineSize: "250px",
                      height: "",
                      inputMode: "email",
                      labelOverride: labelOverride,
                      shouldShowPlaceholder: true,
                      shouldTrimData: true
                    })
                  }), /*#__PURE__*/_jsxs(View, {
                    marginBlockStart: labelOverride ? '900' : '800',
                    children: [/*#__PURE__*/_jsx(Spacer, {
                      space: labelOverride ? '100' : '50'
                    }), /*#__PURE__*/_jsx(Button, {
                      "data-selenium": `${stepKey}_button`,
                      disabled: !isStepDataValid,
                      paddingInline: "700",
                      type: "submit",
                      use: "primary",
                      onClick: onSubmit,
                      children: /*#__PURE__*/_jsx(FormattedMessage, {
                        message: `views.${Step.LandingPage}.nextButtonLabel.verifyEmail`
                      })
                    })]
                  })]
                })
              }), /*#__PURE__*/_jsx(Spacer, {
                space: "500"
              }), /*#__PURE__*/_jsx(PrivacyPolicy, {}), /*#__PURE__*/_jsx(Flex, {
                justifyContent: "center",
                marginBlockStart: "500",
                children: /*#__PURE__*/_jsx(SidePanelHaveAnAccountLink, {
                  accountLinkMessage: getHaveAnAccountMessage(),
                  href: getLoginUrl({
                    redirectUrl: loginRedirectUrl
                  }),
                  onClick: trackLoginClick
                })
              }), !isDesktop && /*#__PURE__*/_jsx(Flex, {
                justifyContent: "center",
                marginBlockStart: "500",
                children: /*#__PURE__*/_jsx(SidePanelManageCookies, {})
              })]
            })]
          })
        })
      })
    })
  });
};